import { FormattedMessage } from 'react-intl';

import { CheckoutDebitCardForm } from './CheckoutDebitCardForm/CheckoutDebitCardForm';
import { StripeDebitCardForm } from './StripeDebitCardForm/StripeDebitCardForm';
import { usePaymentProcessor } from '../../../../../paymentDebitCard/usePaymentProcessor';
import { InnerLayout } from '../../InnerLayout/InnerLayout';

export const DebitCardForm = () => {
    const { paymentProcessor, isLoading, isError } = usePaymentProcessor();

    if (isLoading) return null;
    if (isError) throw new Error('Failed to load payment processor');

    return (
        <InnerLayout
            requirementType="DEBIT_CARD"
            title={
                <FormattedMessage
                    id="_.funding_requirements.debit_card_step.title"
                    defaultMessage="Add debit card for repayments"
                />
            }
            subheading={
                <FormattedMessage
                    id="_.funding_requirements.debit_card_step.subheading"
                    defaultMessage="Your scheduled repayments will come from this debit card."
                />
            }
        >
            {paymentProcessor === 'Checkout' ? (
                <CheckoutDebitCardForm />
            ) : (
                <StripeDebitCardForm />
            )}
        </InnerLayout>
    );
};
